import React from 'react'


import as from '../../image/certificate.json'
    
import coursera from '../../image/cur.jpg'          
import a2i from '../../image/a2i.png'   
import alision from '../../image/alision.jpg'       
import safety from '../../image/safety.png'   
import google from '../../image/google.png'    
import six from '../../image/six.jpg' 
import leaf from '../../image/back/leaf.png'   

import './certificate.css'   

import Lottie from 'react-lottie';
import ScrollAnimation from 'react-animate-on-scroll';
import confetti from 'canvas-confetti'
 
const Certificate = () => {

  var count = 100;
var defaults = {
  origin: { y: 0.7 }
};

function fire(particleRatio, opts) {
  confetti(Object.assign({}, defaults, opts, {
    particleCount: Math.floor(count * particleRatio)
  }));
}

fire(0.25, {
  spread: 26,
  startVelocity: 55,
});
fire(0.2, {
  spread: 60,
});
fire(0.35, {
  spread: 100,
  decay: 0.91,
  scalar: 0.8
});
fire(0.1, {
  spread: 120,
  startVelocity: 25,
  decay: 0.92,
  scalar: 1.2
});
fire(0.1, {
  spread: 120,
  startVelocity: 45,
});

var duration = 18 * 1000;
var animationEnd = Date.now() + duration;
var defaults1 = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}

var interval = setInterval(function() {
  var timeLeft = animationEnd - Date.now();

  if (timeLeft <= 0) {
    return clearInterval(interval);
  }

  var particleCount = 40 * (timeLeft / duration);
  // since particles fall down, start a bit higher than random
  confetti(Object.assign({}, defaults1, { particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } }));
  confetti(Object.assign({}, defaults1, { particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } }));
}, 250);







	return (

<div  style={{ backgroundImage: `url(${""})`, backgroundAttachment: 'fixed', backgroundSize:'cover'}}>
		
 
<ScrollAnimation animateIn='rubberBand'
  initiallyVisible={true}>


<div className="container">
                                                   
<div  class="row" style={{color:'black', background:'#0ff0', border: '#0ff0'}} >
    
     <div class=" col-md-6" >
			    	
		  <Lottie
		      options={{
		        animationData: as,
		        autoplay: true
		      }}
		      height={400}
		      
		    />

	   </div>     
     
      
     <div  class="col-md-6" > 

		   <h2 style={{textAlign:'center'}}>Certifcations </h2>
	   <h4 style={{textAlign: 'justify'}}> All certificates achieved by an online offered by many universities and organization through Coursera and Alison and a2i. Where a2i is offered by the Bangladesh government, which is so helpful for students.  </h4>
     <img src={leaf} class='leaf' alt={""} ></img>





	   </div>


	  </div>         
     
 </div>	 
   
 </ScrollAnimation>






    <div  className="container" style={{color:'black'}}>
         
        <div className="row">
  
            <div id="cat" className="card example-1 square scrollbar-cyan bg-transparent">
              <div id="cat" className="card-body bg-transparent">
                <div className="row">

    <div className="col-md-3" style={{marginBottom:'10px', marginTop:"30px"}}>
                    <div  style={{marginLeft:"5px"}}   className="card">
                      <img className="card-img-top" src={safety}  width={100} height={100} alt={""}/>
                      <div id="card-body"    style={{borderTop: '5px solid black'}} >
                      <ul style={{ textDecoration: 'overline'}}></ul>  
                        <h5 className="card-title" >Course:The COSHH Risk Assessor Certification.</h5>
                        <p>School:The Knights of Safety Academy.</p>
                        <p>Certificate ID:ond6sdhojw | Issued: 2020-09-11</p>
                        <p>Expires:This certification does not expire.</p>
                    </div>
                    <a class="btn btn-sm"  href="https://academy.theknightsofsafety.com/certificates/ond6sdhojw" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                  </div>
    </div>

                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top"  src={coursera} width={100} height={100} alt={""}/>
                      <div  id="card-body"  style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course:Oil &amp; Gas Industry Operations and Markets.</h5>
                        <p>School:Duke University | Coursera.</p>
                        <p>Certificate ID: 64HGVMNTNDAH | Issued: 2020-09</p>
                        <p>Expires:This certification does not expire.</p>
                     </div>
                     <a class="btn btn-sm"  href="https://www.coursera.org/account/accomplishments/verify/64HGVMNTNDAH" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={a2i} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course:Digital Security Essentials.</h5>
                        <p>School:Digital Security Agency.</p>
                        <p>Certificate ID:MC-W2274916X1743069Z106B | Issued: 2020-09</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://muktopaath.gov.bd/certificate/check/MC-W2274916X1743069Z106B" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                    </div>       
                  </div>     
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={alision} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course:Heat Exchanger Types &amp; Applications.</h5>
                        <p>School:Alison.com</p>
                        <p>Certificate ID:1997-18082096 | Issued: 2020-09</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://alison.com/certification/check/%242y%2410%240zPDQKOTcTIq7hzb1QD8Y.p2Y3gfTmEFyD.WBlcuC5MVrgLB8dG7." role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={alision} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course:Industrial Engineering - Control Valve Basics.</h5>
                        <p>School: Alison.com</p>
                        <p>Certificate ID:1804-18082096| Issued: 2020-09</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://alison.com/certification/check/%242y%2410%243gGH16lWZHgLBlzwtm8fDOwsRr7v7V.iMNUhTCGKIhK2Tdv1rysZm" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={alision} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: Advanced Diploma in Chemical Process Safety</h5>
                        <p>School: Alison.com.</p>
                        <p>Certificate ID:1804-18082096| Issued: 2020-10</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://alison.com/certification/check/%242y%2410%24jLO4FjJFGRknjDT799aBOD.RBAG01wfu0b8ZAZU2c1s.mykC1zC" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={a2i} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5  >Course: Project Management and Appraisal Process</h5>
                        <p>School: National Academy for Planning and Development | muktopaath.gov.bd</p>
                        <p>Certificate ID:MC-D2274916K2038789L287A| Issued: 2020-10</p>                       
                      </div>  
                      <a class="btn btn-sm"  href="https://muktopaath.gov.bd/certificate/check/MC-D2274916K2038789L287A" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>

                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top"  src={coursera} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: Engineering Project Management, Risk, Quality, Teams, and Procurement</h5>
                        <p>School: Rice University | Coursera.</p>
                        <p>Certificate ID:STS2FM45R6KJ| Issued: 2020-10</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://www.coursera.org/account/accomplishments/verify/STS2FM45R6KJ" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={coursera} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: HTML, CSS, and Javascript for Web Developers</h5>
                        <p>School: Johns Hopkins University | Coursera. </p>
                        <p>Certificate ID:A6PD6XFJR784| Issued: 2020-10</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://www.coursera.org/account/accomplishments/verify/A6PD6XFJR784" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top"  src={coursera} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course:Programming for Everybody (Getting Started with Python).</h5>
                        <p>School:University of Michigan | Coursera.</p>
                        <p>Certificate ID:NGT5WQLJ86QQ| Issued: 2020-09</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://www.coursera.org/account/accomplishments/verify/NGT5WQLJ86QQ" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={google} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course:The Fundamentals of digital marketing.</h5>
                        <p>School:Google digital garage.</p>
                        <p>Certificate ID: T5P ECB R84 | Issued: 2020-09</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://learndigital.withgoogle.com/link/1qsdpcedm9s" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top"  src={safety} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: Introduction to Business Management.</h5>
                        <p>School:KING'S COLLEGE LONDON | futurelearn</p>
                        <p>Certificate ID: ndzfmzm | Issued: 2020-09</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://www.futurelearn.com/certificates/ndzfmzm" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>

                    </div>
                  </div>  
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={six} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: Lean Six Sigma White Belt Certification</h5>
                        <p>School:COUNCIL FOR SIX SIGMA CERTIFICATION (C.S.S.C)</p>
                        <p>Certificate ID: Hfh 1R7 io23 | Issued: 2020-09</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://certification.sixsigmacouncil.org/mod/customcert/verify_certificate.php?contextid=305" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>

                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={coursera}  width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: Safety in the Utility Industry </h5>
                        <p>School:University at Buffalo| Coursera</p>
                        <p>Certificate ID: T4RHZBKVWNGL | Issued: 2020-10</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://www.coursera.org/account/accomplishments/verify/T4RHZBKVWNGL" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>

                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={coursera}  width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: How to Write a Resume (Project-Centered Course)</h5>
                        <p>School:The State University of New York| Coursera/</p>
                        <p>Certificate ID: 5DMP4DY5UQ89 | Issued: 2020-10</p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://www.coursera.org/account/accomplishments/verify/5DMP4DY5UQ89" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>

                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={a2i} width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title"> Course:Public Speaking A Step-by-Step Guide to Captivating Delivery</h5>
                        <p>School:Bangladesh Youth Leadership Center (BYLC).</p>
                        <p>Certificate ID:MC-R2274916X1868979A138Y| Issued: 2020-09</p>
 
                      </div>
                      <a class="btn btn-sm"  href="https://muktopaath.gov.bd/certificate/check/MC-R2274916X1868979A138Y" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>

                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={coursera}  width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Municipal Solid Waste Management in Developing Countries</h5>
                        <p>School:École Polytechnique Fédérale de Lausanne | Coursera</p>
                        <p>Certificate ID: 3M5ZQPVA8AYR </p>
                        <p>Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://www.coursera.org/account/accomplishments/verify/3M5ZQPVA8AYR" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>

                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={a2i}  width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: The basic idea of Investment</h5>
                        <p>School:Bangladesh Institute of Capital Market | muktopaath.gov.bd/</p>
                        <p>Certificate ID: MC-T2274916R1869284C136D| Issued: 2020-10</p>
 
                      </div>
                      <a class="btn btn-sm"  href="https://muktopaath.gov.bd/certificate/check/MC-T2274916R1869284C136D" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>

                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={a2i}  width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: (BTT) বেসিক টিচার্স ট্রেনিং কোর্স- ৫ম ব্যাচ</h5>
                        <p>School:Muktopaath | muktopaath.gov.bd/</p>
                        <p>Certificate ID: MC-W2274916A2259646J126X | Issued: 2020-10</p>

                      </div>
                      <a class="btn btn-sm"  href="https://muktopaath.gov.bd/certificate/check/MC-W2274916A2259646J126X#" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""}/> View certificate</a>

                    </div>
                  </div>
                  <div className="col-md-3">
                    <div style={{marginBottom:'10px', marginTop:"30px"}} className="card">
                      <img className="card-img-top" src={a2i}  width={100} height={100} alt={""}/>
                      <div  id="card-body" style={{borderTop: '5px solid black'}} >
                        <h5 className="card-title">Course: LinkedIn </h5>
                        <p>School:Robi 10 Minute School | muktopaath.gov.bd/</p>
                        <p>Certificate ID: MC-B2274916O1931570Y190R | Issued: 2020-10</p>
                        <p >Expires:This certification does not expire.</p>
                      </div>
                      <a class="btn btn-sm"  href="https://muktopaath.gov.bd/certificate/check/MC-B2274916O1931570Y190R" role="button"><img src="https://img.icons8.com/fluency-systems-filled/28/000000/external-link.png" alt={""} /> View certificate</a>
                    </div>
                  </div>
                 </div>
              </div>        
            </div>
          </div>
      </div>









 <div style={{marginBottom:'100px'}}>    
 </div>
 


</div>






	)
}

export default Certificate